import { useTranslation } from 'react-i18next';

import type { ForumComment } from '~/api/forum/types';

import { useDeleteForumComment } from '~/api/forum/useDeleteForumComment';
import { AlertDialog, Button } from '~/components';
import { toast } from '~/utils/toast';

type Props = {
  comment: ForumComment;
  onClose: () => void;
};

export const ConfirmDeleteForumCommentDialog = ({ comment, onClose }: Props) => {
  const mutation = useDeleteForumComment(comment.id, comment.postId);

  const { t } = useTranslation(['forum']);

  const onDelete = () =>
    mutation.mutate(undefined, {
      onSuccess: () => {
        toast.success({ description: t('forum:alerts.deleteComment.success') });
        onClose();
      },
      onError: () => toast.danger({ description: t('forum:alerts.deleteComment.error') }),
    });

  return (
    <AlertDialog.Body status="danger">
      <AlertDialog.Title>{t('forum:deleteComment.title')}</AlertDialog.Title>

      <AlertDialog.Description>{t('forum:deleteComment.description')}</AlertDialog.Description>

      <AlertDialog.Actions>
        <Button emphasis="status" icon="Trash" loading={mutation.isPending} onClick={onDelete}>
          {t('forum:deleteComment.actions.confirm')}
        </Button>
      </AlertDialog.Actions>
    </AlertDialog.Body>
  );
};
